module.exports = __webpack_public_path__ + "img/certificate-EC-basic.13488bd3.jpg";